import React from "react";
import { SinggleMenu } from "./Sidebar";

const HumasPemasaran = ({ user }) => {
  return (
    <>
      {user.jabatan === "IT Programmer" ||
      user.jabatan === "Dir. Humas & Pemasaran" ||
      user.jabatan === "Internet Marketing" ||
      user.jabatan === "Kepala Cabang Denpasar" ||
      user.jabatan === "Kepala Cabang Singaraja" ||
      user.jabatan === "Kepala Cabang Karangasem" ||
      user.jabatan === "Ka. Bag. Humas & Pemasaran" ||
      user.jabatan === "Bagian Humas & Pemasaran" ||
      user.jabatan === "Ka. Unit Resepsionis" ||
      // custom
      user.nama === "Ayu Aprilyana Kusuma Dewi, S.Kom." ||
      user.jabatan === "Resepsionis" ? (
        <>
          <hr className="border-0 my-2" />

          <div className="sidebar-heading text-black bg-gradient-warning mx-2 rounded font-weigh-bold py-1">
            Humas & Pemasaran
          </div>

          <hr className="sidebar-divider border-0 mt-2 mb-0" />

          <SinggleMenu title="Afiliasi" fa="fa-users" link="/afiliasi-hp" />
          <SinggleMenu title="Pendaftar" fa="fa-users" link="/pendaftar-hp" />
        </>
      ) : null}
    </>
  );
};

export default HumasPemasaran;
